import api from "./api";
import qsStringify from "./qsStringify";

export const getNewsList = (locale, queries) => {
  const query = qsStringify({
    populate: ["thumbnail", "categories.sort", "gallery"],
    sort: ["datetime:desc"],
    ...queries,
  });
  return api.get(`/news-lists?locale=${locale}&${query}`).then(res => res.data);
};

export const getRandomNewsItem = (id, locale) => {
  return api
    .get(`/news-list/random?locale=${locale}&id_nin=${id}`)
    .then(res => res.data);
};
